import { useAppSelector } from '@app/redux/hooks';
import { selectUserAgent } from '@app/redux/slices/header';
import { useState, useEffect } from 'react';

export function useWindowSizing(fracture) {
  const { isMobile } = useAppSelector(selectUserAgent);
  const [mobileWindow, setMobileWindow] = useState<boolean>(isMobile);
  useEffect(() => {
    if (window) {
      const handleChange = () => (document.documentElement.clientWidth > fracture ? setMobileWindow(false) : setMobileWindow(true));
      handleChange();
      window.addEventListener('resize', handleChange);
      return () => window.removeEventListener('resize', handleChange);
    }
  }, [fracture]);
  return mobileWindow;
}
